import React from "react";
import "./button.css";
var Button = function Button(_ref) {
  var _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? "light" : _ref$theme,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 50 : _ref$height,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 180 : _ref$width,
    border = _ref.border,
    logo = _ref.logo,
    storeName = _ref.storeName,
    title = _ref.title,
    url = _ref.url,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      return url && window.open(url, "_blank");
    },
    style: {
      height: height,
      width: width,
      borderRadius: border
    },
    className: "button-container button-container-".concat(theme, " ").concat(className)
  }, /*#__PURE__*/React.createElement("img", {
    src: logo,
    alt: storeName
  }), /*#__PURE__*/React.createElement("div", {
    className: "button-text-container"
  }, /*#__PURE__*/React.createElement("span", {
    className: "button-title"
  }, title), /*#__PURE__*/React.createElement("span", {
    className: "button-store-name"
  }, storeName)));
};
export default Button;